import {
  call,
  put,
  takeEvery,
  all,
  takeLatest,
  fork,
} from "redux-saga/effects";
import Constants from "../../constants/AuthConstant";
import JwtAuthService from "../../../services/JwtAuthService";
import { notification } from "antd";
import { setCookie } from "../../../utils/AllCookies";
import TenantAction from "../../actions/AuthAction/TenantAction";
import Swal from "sweetalert2";

function* tenantSaga(action) {
  try {
    const response = yield call(
      JwtAuthService.getAPI,
      "",
      "user/GetAllStatesCitiesAndCommunities"
    );
    yield put(TenantAction.TenantSuccess(response));
  } catch (error) {
    yield put(TenantAction.TenantFailure(error.message));
  }
}

function* GetAllCitiesFromState() {
 
    yield takeLatest(Constants.GET_ALLCITIESFROMSTATE_REQUEST, getCitySaga);
}

function* getCitySaga({ payload: stateId }) {
  try {
    const response = yield call(JwtAuthService.getAPI, "",`user/GetAllCitiesFromState?stateId=${stateId}`);
    yield put(TenantAction.GetAllCitiesFromStateSuccess(response));
  } catch (error) {
    yield put(TenantAction.GetAllCitiesFromStateFailure(error.message));
  }
}

function* tenant() {
  yield takeLatest(Constants.TENANT_REQUEST, tenantSaga);
}

function* CreateTenantSaga(action) {
  try {
    const response = yield call(
      JwtAuthService.postApi,
      action?.payload?.request,
      "api/tenant/TenantRegistrationV1"
    );

    console.log(response, "SANDHYA");

    yield put(TenantAction.CreateTenantSuccess(response));
  } catch (error) {
    Swal.fire({
      text: "Submission unsuccessful. Please try again or contact us.",
      icon: "error",
      confirmButtonColor: "#5A7890",
      customClass: {
        title: "text-danger", // Custom class for the title text
        content: "text-danger", // Custom class for the content text
      },
    });
    yield put(TenantAction.CreateTenantFailure(error.message));
  }
}

function* PaymentTenantSaga(action) {
  try {
    const response = yield call(
      JwtAuthService.postApi,
      action?.payload?.request,
      "api/Tenant/TenantPayment"
    );

    yield put(TenantAction.UpdatePaymentTenantSuccess(response));
  } catch (error) {
    Swal.fire({
      text: "Payment unsuccessful. Please try again or contact us.",
      icon: "error",
      confirmButtonColor: "#5A7890",
      customClass: {
        title: "text-danger", // Custom class for the title text
        content: "text-danger", // Custom class for the content text
      },
    });
    yield put(TenantAction.UpdatePaymentTenantFailure(error.message));
  }
}

function* SkippedPaymentSaga(action) {
  try {
    const response = yield call(
      JwtAuthService.postApi,
      { registrationId: action?.payload?.id, paymentToken: action?.payload?.paymentToken },
      "api/Tenant/NewRegistrationPaymentSkipped"
    );

    yield put(TenantAction.SetSkippedPaymentSuccess(response));
  } catch (error) {
    yield put(TenantAction.SetSkippedPaymentFailure(error.message));
  }
}

function* CreateTenant() {
  yield takeLatest(Constants.CREATE_TENANT_REQUEST, CreateTenantSaga);
  yield takeLatest(Constants.UPDATE_TENANT_PAYEMENT_REQUEST, PaymentTenantSaga);
  yield takeLatest(Constants.SET_SKIPPED_PAYMENT_REQUEST, SkippedPaymentSaga);
}

export default function* rootSaga() {
  yield all([fork(tenant), fork(CreateTenant), GetAllCitiesFromState()]);
}
